import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1] } },
};

export default function HeroCopy() {
  return (
    <>
      <motion.div
        initial="hidden"
        animate="show"
        variants={fadeUp}
        className="iw-overline mb-4"
        data-testid="hero-brand-overline"
      >
        Integrated Clinical Intelligence
      </motion.div>

      <motion.h1
        initial="hidden"
        animate="show"
        variants={fadeUp}
        transition={{ delay: 0.05 }}
        className="font-display font-bold tracking-normal leading-[1.04]
                   text-[clamp(2.15rem,4.2vw,3.7rem)]"
      >
        <span className="text-primary">Your Health Is Connected. </span>
        <br className="hidden sm:block" />
        <span className="text-foreground/85">Your Healthcare </span>
        <span className="text-accent">Should Be Too.</span>
      </motion.h1>

      <motion.p
        initial="hidden"
        animate="show"
        variants={fadeUp}
        transition={{ delay: 0.15 }}
        data-testid="hero-tagline"
        className="mt-6 max-w-2xl text-base md:text-lg text-foreground/80 leading-relaxed text-pretty"
      >
        Integrated Wellness combines your goals, symptoms, labs, body composition, wearables,
        genetics, microbiome data and health history into{" "}
        <em className="not-italic text-primary font-semibold">
          one intelligent optimization profile
        </em>{" "}
        — helping you and your clinical team understand what to optimize next.
      </motion.p>
    </>
  );
}
